<h1  style="display: flex; align-items: center;">OBIETTIVI</h1>
<div class="text">
	<p>
		L'iniziativa De Componendis Cifris si propone di animare la comunità
		crittografica Italiana, sia nelle sue componenti accademiche, sia nelle
		sue ramificazioni nel mondo del lavoro e dell'impresa. La De Cifris
		auspica che l'Italia possa sviluppare cifrari robusti e flessibili,
		adatti all'era moderna, e che emergano talenti dedicati alle scienze crittografiche.
	</p>
	<p>
		In particolare, tra gli obiettivi proponiamo:
	</p>

	<ul>
		<li> Incentivare in Italia lo studio
			e le ricerche nell'ambito della Crittografia
			a livello sia accademico sia applicativo, con particolare attenzione alle aree
			della Matematica, dell'Informatica e dell'Ingegneria.</li>
		<li> Sostenere la realizzazione di qualificati progetti di ricerca che richiedano
			il coinvolgimento e le collaborazioni di numerosi studiosi appartenenti a
			discipline anche molto diverse. </li>
		<li> Divulgare l'uso responsabile della crittografia, favorendo il formarsi di una
			cultura propria e autonoma. </li>
		<li> Contribuire al rafforzamento della cooperazione internazionale in questo settore
			sia in ambito scientifico, sia nell'ambito del suo impiego, anche con principi di
			solidarietà.</li>
	</ul>
</div>